import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import { ErrorContext } from './error';
import { adsFieldAlias } from '../validators';

export const withError = (WrappedComponent, property) => (
  React.memo((props) => {
    const { errors } = useContext(ErrorContext);

    const filteredErrors = useMemo(() => {
      if (!_.isEmpty(property)) {
        return _.filter(errors, error => error.Property === property ||
          error.Property === adsFieldAlias[property]);
      }
      return errors;
    }, [errors]);

    const errorMessage = _.isEmpty(filteredErrors) ? undefined : _.map(filteredErrors, error => error.Message || error.Code).join('\n');

    return (
      <WrappedComponent
        errorMessage={errorMessage}
        {...props}
      />
    );
  })
);
